var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#print_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    fillRule: "evenodd",
    d: "M3.25.5V3h7.5V.5a.5.5 0 0 0-.5-.5h-6.5a.5.5 0 0 0-.5.5m.638 9V13c0 .133.047.26.13.354a.422.422 0 0 0 .314.146h5.336a.422.422 0 0 0 .314-.146.534.534 0 0 0 .13-.354V9.5zM.45 4.804a1.53 1.53 0 0 1 1.049-.41h11c.388 0 .766.144 1.05.41.284.267.45.636.45 1.029v4.227c0 .393-.166.762-.45 1.03-.284.265-.662.41-1.05.41h-1.138v-2c0-.69-.56-1.25-1.25-1.25H3.888c-.69 0-1.25.56-1.25 1.25v2H1.5c-.388 0-.766-.145-1.05-.41A1.412 1.412 0 0 1 0 10.06V5.833c0-.393.166-.762.45-1.029m8.864 1.444c0-.345.28-.625.625-.625h1.637a.625.625 0 1 1 0 1.25H9.94a.625.625 0 0 1-.626-.625",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "print_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgPrint;